import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/salesHome'
import allApps from '../components/allapp'
// import Services from '../components/services'
// import Support from '../components/support'
// import About from '../components/about'
import Help from '../components/helpCenter'
import Detail from '../components/detail'
import Article from '../components/article'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      // name: 'Home',
      // component: Home,
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    // {
    //   path: '/services',
    //   name: 'Services',
    //   component: Services
    // },
    {
      path: '/allapps',
      name: 'allApps',
      component: allApps
    },
    // {
    //   path: '/support',
    //   name: 'Support',
    //   component: Support
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About
    // },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/help/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/article',
      name: 'Article',
      component: Article
    },
  ],
  scrollBehavior (to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js